<template>
  <textarea
    ref="textarea"
    v-model="value"
    :style="computedStyles"
  />
</template>

<script>
/**
 * Vue 3 replacement for the `vue-textarea-autosize` plugin (SP-14741).
 *
 * Registered globally as `textarea-autosize` so the existing call sites keep
 * working. Attributes (`id`, `class`, `placeholder`, `maxlength`, `disabled`,
 * `autofocus`, focus listeners) fall through to the textarea element.
 */
export default {
  name: 'TextareaAutosize',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    minHeight: {
      type: Number,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      height: 'auto',
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    computedStyles() {
      return {
        resize: 'none',
        height: this.height,
        overflow: 'hidden',
      };
    },
  },
  watch: {
    modelValue() {
      this.$nextTick(this.resize);
    },
  },
  mounted() {
    this.resize();
  },
  methods: {
    resize() {
      const { textarea } = this.$refs;

      if (!textarea) {
        return;
      }

      // The element must be free to shrink before its content height is read,
      // otherwise removing text never reduces the box.
      this.height = 'auto';

      this.$nextTick(() => {
        let contentHeight = textarea.scrollHeight + 1;

        if (this.minHeight && contentHeight < this.minHeight) {
          contentHeight = this.minHeight;
        }

        this.height = `${contentHeight}px`;
      });
    },
  },
};
</script>
